export default __webpack_public_path__ + "img/53519b42cdc86a1f49796b2be3495890.svg";